module.exports = __webpack_public_path__ + "static/media/video-outline.a791e2f5.svg";